import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../index';
import { GameSession, ScreenMode } from '../types';
import { GroupRanking } from './GroupRanking';
import { IndividualRanking } from './IndividualRanking';
import { QRCodeScreen } from './QRCodeScreen';

export const UnifiedScreen: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const [session, setSession] = useState<GameSession | null>(null);

  useEffect(() => {
    if (!sessionId) return;

    const unsubscribe = onSnapshot(
      doc(db, 'battleRoyale', sessionId),
      (doc) => {
        if (doc.exists()) {
          setSession({ id: doc.id, ...doc.data() } as GameSession);
        }
      }
    );

    return () => unsubscribe();
  }, [sessionId]);

  // スクリーンモードに応じて表示するコンポーネントを決定
  const screenMode = session?.settings?.screenMode || ScreenMode.GROUP_6;
  
  console.log('UnifiedScreen - screenMode:', screenMode);
  console.log('UnifiedScreen - session settings:', session?.settings);
  
  if (screenMode === ScreenMode.QR_CODE) {
    return <QRCodeScreen />;
  } else if (screenMode === ScreenMode.INDIVIDUAL) {
    return <IndividualRanking />;
  } else {
    // GROUP系は同じGroupRankingコンポーネントを使用
    let maxRankToShow = 6;
    if (screenMode === ScreenMode.GROUP_4) {
      maxRankToShow = 4;
    } else if (screenMode === ScreenMode.GROUP_3) {
      maxRankToShow = 3;
    }
    
    console.log('UnifiedScreen - maxRankToShow:', maxRankToShow);
    
    // セッションの設定を一時的に上書き
    if (session) {
      session.settings.showTop3Only = screenMode === ScreenMode.GROUP_3;
      // maxRankToShowを渡すために新しいプロパティを追加
      (session.settings as any).maxRankToShow = maxRankToShow;
    }
    
    return <GroupRanking maxRankToShow={maxRankToShow} />;
  }
};